import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

const DashboardPsicologico = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        asesorias_totales: null, 
        asesorias_curso: null, 
        asesorias_finalizadas: null, 
        dia_mas: null, 
        dia_menos: null, 
        horario_mas: null, 
        horario_menos: null, 
        cliente_asesorado: null, 
        cliente_contactado: null, 
        cliente_reciente: null, 
        ultima_curso: null, 
        ultima_finalizada: null, 
        ultimo_contacto: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('asesor'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                asesorias_totales: detalles.asesorias_totales, 
                asesorias_curso: detalles.asesorias_curso, 
                asesorias_finalizadas: detalles.asesorias_finalizadas, 
                dia_mas: detalles.dia_mas, 
                dia_menos: detalles.dia_menos, 
                horario_mas: detalles.horario_mas, 
                horario_menos: detalles.horario_menos, 
                cliente_asesorado: detalles.cliente_asesorado, 
                cliente_contactado: detalles.cliente_contactado, 
                cliente_reciente: detalles.cliente_reciente, 
                ultima_curso: detalles.ultima_curso, 
                ultima_finalizada: detalles.ultima_finalizada, 
                ultimo_contacto: detalles.ultimo_contacto
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    ¡Hola {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}!
                </h4>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Asesorías</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.asesorias_totales != null && dashboardData.asesorias_totales != undefined ? formatNumber(dashboardData.asesorias_totales, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">totales</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.asesorias_curso != null && dashboardData.asesorias_curso != undefined ? formatNumber(dashboardData.asesorias_curso, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">en curso</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.asesorias_finalizadas != null && dashboardData.asesorias_finalizadas != undefined ? formatNumber(dashboardData.asesorias_finalizadas, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">finalizadas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Días</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.dia_mas != null && dashboardData.dia_mas != undefined ? dashboardData.dia_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más contactado</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.dia_menos != null && dashboardData.dia_menos != undefined ? dashboardData.dia_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos contactado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Horarios</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.horario_mas != null && dashboardData.horario_mas != undefined ? dashboardData.horario_mas + ':00' : 'Sin definir'}</p>
                                <p className="subtitulo">más contactado</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.horario_menos != null && dashboardData.horario_menos != undefined ? dashboardData.horario_menos + ':00' : 'Sin definir'}</p>
                                <p className="subtitulo">menos contactado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Destacados</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_asesorado != null && dashboardData.cliente_asesorado != undefined ? dashboardData.cliente_asesorado : 'Sin definir'}</p>
                                <p className="subtitulo">cliente más asesorado</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_contactado != null && dashboardData.cliente_contactado != undefined ? dashboardData.cliente_contactado : 'Sin definir'}</p>
                                <p className="subtitulo">cliente más contactado</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_reciente != null && dashboardData.cliente_reciente != undefined ? dashboardData.cliente_reciente : 'Sin definir'}</p>
                                <p className="subtitulo">cliente más reciente</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Mis acciones</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.ultima_curso != null && dashboardData.ultima_curso != undefined ? new Date(dashboardData.ultima_curso).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(dashboardData.ultima_curso).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' }</p>
                                <p className="subtitulo">última asesoría iniciada</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.ultima_finalizada != null && dashboardData.ultima_finalizada != undefined ? new Date(dashboardData.ultima_finalizada).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(dashboardData.ultima_finalizada).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' }</p>
                                <p className="subtitulo">última asesoría finalizada</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.ultimo_contacto != null && dashboardData.ultimo_contacto != undefined ? new Date(dashboardData.ultimo_contacto).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(dashboardData.ultimo_contacto).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' }</p>
                                <p className="subtitulo">último contacto</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardPsicologico;